import { useMemo } from 'react'
import { IPassportReference } from '@obvious.tech/constellation'
import Loadable, { TLoadable } from 'src/utils/Loadable'

export type TUseAlarmAssignedEntityResult = TLoadable<
  TPassportReference | TGroupReference | null
>

export type TPassportReference = {
  _tag: 'Passport'
  id: string
  username: string
}

export type TGroupReference = {
  _tag: 'Group'
  id: string
  name: string
}

export const useAlarmAssignedEntity = ({
  assignedEntity,
}: {
  assignedEntity: IPassportReference | undefined
}): TUseAlarmAssignedEntityResult => {
  return useMemo(() => {
    if (typeof assignedEntity?.passportId !== 'string')
      return Loadable.successW(null)

    if (typeof assignedEntity?.userName !== 'string')
      return Loadable.failureW(
        new Error(
          'Reference cannot be discriminated between Group and Passport (has no "userName" property).',
        ),
      )

    if (isGroupName(assignedEntity.userName)) {
      return Loadable.successW({
        _tag: 'Group',
        id: assignedEntity.passportId,
        name: assignedEntity.userName,
      })
    }

    return Loadable.successW({
      _tag: 'Passport',
      id: assignedEntity.passportId,
      username: assignedEntity.userName,
    })
  }, [assignedEntity?.passportId, assignedEntity?.userName])
}

const isGroupName = (it: string): boolean => /^\/.*\/$/.test(it)
